import { render, staticRenderFns } from "./shipment-rules-grid.vue?vue&type=template&id=2959d313&scoped=true&"
import script from "./shipment-rules-grid.ts?vue&type=script&lang=ts&"
export * from "./shipment-rules-grid.ts?vue&type=script&lang=ts&"
import style0 from "./shipment-rules-grid.scss?vue&type=style&index=0&id=2959d313&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959d313",
  null
  
)

export default component.exports